import React, { Fragment, useState, useEffect } from 'react';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import _ from 'lodash';

export default function FilterSelect(props) {
   const [value, setValue] = useState(null);
   const [options, setOptions] = useState([]);

   useEffect(() => {
      setValue(_.find(props.options, o => { return o.value === props.value?.value }));
      setOptions(props.options || []);
   }, [props.value, props.options])

   function onChange(selection) {
      const label = selection === null ? null : selection.label;
      props.onChangeCallback({
         filterName: props.filterName,
         value: selection === null ? null : selection.value,
         label: label,
         filteredDisplay: selection === null
            ? ''
            : `${props.displayName}: ${label}`
      });
   }

   if (!options) return null;
   return (
      <Fragment>
         {props.displayName && !props.hideDisplayName ?
            <div className="filter-definition-caption">{props.displayName}</div>
            : null}
         <span style={props.style}>
            <Select
               classNamePrefix='serviceThreadSelect'
               closeMenuOnSelect={true}
               isMulti={false}
               components={makeAnimated()}
               options={options}
               onChange={onChange}
               isClearable={props.isClearable}
               isDisabled={props.disabled || false}
               value={value}
               onBlurResetsInput={false}
               onSelectResetsInput={false}
               onCloseResetsInput={false}
            />
         </span>
      </Fragment>
   );
}
